import { client } from "../client";
import type { AdminStats } from "../types/auth.types";

export const fetchAdminStats = async (
	interval: "week" | "month" | "year",
	date: Date,
) => {
	const params = new URLSearchParams();
	params.append("interval", interval);
	params.append("date", date.toISOString());
	const response = await client.get<AdminStats[]>(`auth/admins/stats`, {
		params,
	});
	return response.data;
};
